




























































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import PositionDto from '@/models/Positions/PositionDto';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Validator from '@/lib/validator';
import UpdatePositionRequest from '@/models/Positions/UpdatePositionRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'PositionEdit'
})
export default class extends GiganautVueDialog {
 
    public entity = new PositionDto();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentPosition));
        }
    }

    get skills() {
        return AgencySettingsModule.skills;
    }

     get industries() {
        return AgencySettingsModule.industries;
    }

     get qualifications() {
        return AgencySettingsModule.qualifications;
    }

    get uniforms() {
        return AgencySettingsModule.uniforms;
    }

    get loading() {
        return AgencySettingsModule.loadingDialog;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        const request = new UpdatePositionRequest()
        request.updatedAt = AgencySettingsModule.currentPosition.updatedAt;
        request.name = this.entity.name;
        request.description = this.entity.description
        request.industryId = this.entity.industry.id
        request.minimumHours = this.entity.minimumHours;
        request.skillIds = this.entity.skills.map(( {id }) => id);
        request.qualificationIds = this.entity.qualifications.map(( {id }) => id);
        request.uniformIds = this.entity.uniforms.map(( {id }) => id);
        await AgencySettingsModule.editPosition(request);
        this.dialog = false;
    }
}
